<template>
	<router-view />
</template>

<script>
export default {
	name: "App",
	data() {
		return {};
	},
	methods: {}
};
</script>

<style>
.el-autocomplete-suggestion {
	width: 448px !important;
}
.el-loading-mask {
	/* height: calc(100vh - 70px); */
	/* background-color: rgba(255,255,255,.2)!important; */
}
.el-message--success {
	background-color: #d5001c !important;
	border-color: #d5001c !important;
}
.el-message--warning,
.el-message--error,
.el-message--info {
	background-color: #000 !important;
	border-color: #000 !important;
}

.el-icon-success,
.el-icon-warning,
.el-icon-error,
.el-icon-info,
.el-message__content {
	color: #fff !important;
}
.el-cascader-node__label {
	color: #000 !important;
}
.el-button,
.el-input__inner {
	border-radius: 0 !important;
}
.cursor {
	cursor: pointer;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #d5001c !important;
}
.el-pagination__total {
	display: none !important;
}
img[src=""],
img:not([src]) {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue